document.addEventListener("DOMContentLoaded", function () {
  initModalObserver();
  patchCtoCartDrawerForInsuranceFlow();
  initGwpSyncAfterSwRemove();
});

let lastOpenedModalId = null;
let addOtherIInsuranceItem = {
  status: false,
  data: {},
};

const isCtoMainItem = (item) => !!(item?.properties?._cto_product || item?.properties?._added_from_pdp);

function patchCtoCartDrawerForInsuranceFlow() {
  const applyPatch = () => {
    const CTOCartDrawer = customElements.get("cto-cart-drawer");
    if (!CTOCartDrawer?.prototype || CTOCartDrawer.prototype.__insuranceSelectionPatchApplied) return;

    const prototype = CTOCartDrawer.prototype;
    const originalOpen = prototype.open;
    const originalUpdateCtoItemKey = prototype.updateCtoItemKey;

    const PDP20_MAIN_SELECTOR = '.cto-cart-item[data-cto-product="true"]';
    const PDP10_MAIN_SELECTOR = '.cto-cart-item[data-added-from-pdp="true"]';
    const ANY_MAIN_SELECTOR = `${PDP20_MAIN_SELECTOR}, ${PDP10_MAIN_SELECTOR}`;

    const getTemplate = () => document.body?.dataset?.template || "";
    const isPdp20Like = (template) => template.includes("pdp-2.0") || template.includes("plp-new");
    const getLocalMainKey = () => window.localStorage?.getItem("cart_new_item_key");
    const findDrawerItemByKey = (drawer, key) =>
      key ? drawer.querySelector(`.cto-cart-item[data-cto-cart-item-key="${key}"]`) : null;

    const getScopedMainItems = (drawer, template) => {
      const scopedSelector = isPdp20Like(template) ? PDP20_MAIN_SELECTOR : PDP10_MAIN_SELECTOR;
      const scopedItems = Array.from(drawer.querySelectorAll(scopedSelector));
      if (scopedItems.length) return scopedItems;
      return Array.from(drawer.querySelectorAll(ANY_MAIN_SELECTOR));
    };

    const getTokenRelatedMainKeys = (drawer, token) => {
      if (!token) return [];
      return Array.from(
        drawer.querySelectorAll(
          `.cto-cart-item[data-token="${token}"][data-cto-product="true"], .cto-cart-item[data-token="${token}"][data-added-from-pdp="true"]`
        )
      )
        .map((item) => item.dataset.ctoCartItemKey)
        .filter(Boolean);
    };

    const findMainSkuFromAddonItems = (items) => {
      if (!Array.isArray(items)) return null;
      for (const item of items) {
        const props = item?.properties || {};
        const sku = props._sw_main_product_sku || props._aplcr_main_product_sku || props._gwp_main_product_sku;
        if (sku) return sku;
      }
      return null;
    };

    const findPreferredMainItemInPayload = (items, template, currentKey = null) => {
      if (!Array.isArray(items) || !items.length) return null;

      if (currentKey) {
        const currentItem = items.find((item) => item?.key === currentKey && isCtoMainItem(item));
        if (currentItem) return currentItem;
      }

      const templateMainItem = isPdp20Like(template)
        ? items.find((item) => !!item?.properties?._cto_product)
        : items.find((item) => !!item?.properties?._added_from_pdp);

      if (templateMainItem) return templateMainItem;
      return items.find(isCtoMainItem) || null;
    };

    const findMainItemInDrawerBySku = (drawer, sku) => {
      if (!sku) return null;

      const allMainItems = Array.from(drawer.querySelectorAll(ANY_MAIN_SELECTOR));
      if (!allMainItems.length) return null;

      const skuItems = allMainItems.filter((item) => item?.dataset?.sku === sku);
      const targetItems = skuItems.length ? skuItems : allMainItems;

      const preferredKeys = [drawer.ctoItemKey, drawer.__insurancePreferredMainKey, getLocalMainKey()];
      for (const key of preferredKeys) {
        if (!key) continue;
        const preferredItem = targetItems.find((item) => item?.dataset?.ctoCartItemKey === key);
        if (preferredItem) return preferredItem;
      }

      return targetItems.find((item) => item.classList.contains("active")) || targetItems[targetItems.length - 1] || null;
    };

    const mapSingleMainKey = (drawer, key, sku) => {
      if (!key || !sku) return false;
      drawer.currentItemsSkus = {};
      drawer.currentSkuKeyPair = {};
      drawer.currentItemsSkus[sku] = true;
      drawer.currentSkuKeyPair[key] = sku;
      drawer.updateCtoItemKey(key);
      return true;
    };

    prototype.updateCtoItemKey = function (ctoItemKey) {
      if (!ctoItemKey) {
        return this.ctoItemKey;
      }

      this.__insurancePreferredMainKey = ctoItemKey;
      return originalUpdateCtoItemKey.call(this, ctoItemKey);
    };

    prototype.updateCurrentItemsSkus = function (itemsData) {
      const normalizedItemsData = Array.isArray(itemsData) ? itemsData : [];
      if (!normalizedItemsData.length) {
        // Keep the previous mapping when cart.js refreshes drawer without passing updated items.
        return;
      }

      const productTemplate = getTemplate();
      let mainItem = findPreferredMainItemInPayload(normalizedItemsData, productTemplate, this.ctoItemKey);

      // cart/add.js responses for add-ons (insurance/applecare/gwp) can contain only child items.
      // In that case, infer the parent SKU and keep drawer focus on that parent main item.
      if (!mainItem) {
        const inferredMainSku = findMainSkuFromAddonItems(normalizedItemsData);
        const drawerMainItem = findMainItemInDrawerBySku(this, inferredMainSku);
        if (drawerMainItem?.dataset?.ctoCartItemKey) {
          mainItem = {
            key: drawerMainItem.dataset.ctoCartItemKey,
            sku: drawerMainItem.dataset.sku || inferredMainSku,
          };
        }
      }

      if (mapSingleMainKey(this, mainItem?.key, mainItem?.sku)) {
        return;
      }

      this.currentItemsSkus = {};
      this.currentSkuKeyPair = {};
      normalizedItemsData.forEach((item) => {
        this.currentItemsSkus[item.sku] = true;
        this.currentSkuKeyPair[item.key] = item.sku;
      });
    };

    prototype.open = function (...args) {
      const response = originalOpen.apply(this, args);

      const productTemplate = getTemplate();
      const mainItems = getScopedMainItems(this, productTemplate);

      const preferredMainItem =
        findDrawerItemByKey(this, this.ctoItemKey) ||
        findDrawerItemByKey(this, this.__insurancePreferredMainKey) ||
        findDrawerItemByKey(this, getLocalMainKey()) ||
        mainItems[mainItems.length - 1] ||
        null;

      const mainKey = preferredMainItem?.dataset?.ctoCartItemKey;
      if (!mainKey) {
        return response;
      }

      this.currentItemsSkus = {};
      this.currentSkuKeyPair = {};
      this.updateCtoItemKey(mainKey);

      const tokenRelatedMainKeys = getTokenRelatedMainKeys(this, preferredMainItem?.dataset?.token);
      this.updateSkuKeyPair(tokenRelatedMainKeys.length ? tokenRelatedMainKeys : [mainKey], []);
      this.updateLatestCartItems();

      return response;
    };

    prototype.__insuranceSelectionPatchApplied = true;
  };

  if (customElements.get("cto-cart-drawer")) {
    applyPatch();
  } else {
    customElements.whenDefined("cto-cart-drawer").then(applyPatch).catch(() => {});
  }
}

function initGwpSyncAfterSwRemove() {
  if (document.body.dataset.insuranceSwremoveSyncAttached === "true") return;
  document.body.dataset.insuranceSwremoveSyncAttached = "true";

  const parseSkuList = (skuString) =>
    (skuString || "")
      .split(",")
      .map((sku) => sku.trim())
      .filter(Boolean);

  const postCartChange = async (payload) => {
    return fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    }).then((response) => response.json());
  };

  const getCartData = async () => {
    return fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
  };

  const findTargetMainItem = (cartItems, mainSku, fallbackGwpSkus = []) => {
    const mainCandidates = (cartItems || []).filter(
      (item) => item?.sku === mainSku && (item?.properties?._cto_product || item?.properties?._added_from_pdp)
    );

    if (!mainCandidates.length) return null;

    const withGwp = mainCandidates.filter((item) => parseSkuList(item?.properties?._gwp_sku).length);
    if (withGwp.length === 1) return withGwp[0];
    if (withGwp.length > 1) {
      const withMatchingSku = withGwp.find((item) => {
        const gwpSkus = parseSkuList(item?.properties?._gwp_sku);
        return fallbackGwpSkus.some((sku) => gwpSkus.includes(sku));
      });
      return withMatchingSku || withGwp[0];
    }

    return mainCandidates[0];
  };

  const syncGwpUuidForMainItem = async ({ mainSku, mainHandle, fallbackGwpSkus = [] }) => {
    const cartData = await getCartData();
    const cartItems = Array.isArray(cartData?.items) ? cartData.items : [];
    const mainItem = findTargetMainItem(cartItems, mainSku, fallbackGwpSkus);

    if (!mainItem?.properties?._uuid) return false;

    const targetUuid = mainItem.properties._uuid;
    const mainGwpSkus = parseSkuList(mainItem.properties._gwp_sku);
    const expectedGwpSkus = mainGwpSkus.length ? mainGwpSkus : fallbackGwpSkus;

    if (!expectedGwpSkus.length) return false;

    const mismatchedGwpItems = cartItems.filter((item) => {
      if (!expectedGwpSkus.includes(item?.sku)) return false;
      if (item?.properties?._gwp_main_product_sku !== mainSku) return false;
      if (mainHandle && item?.properties?._gwp_main_product_handle && item.properties._gwp_main_product_handle !== mainHandle) {
        return false;
      }
      return item?.properties?._uuid !== targetUuid;
    });

    if (!mismatchedGwpItems.length) return false;

    for (const gwpItem of mismatchedGwpItems) {
      const nextProperties = {
        _gwp_main_product_sku: mainSku,
        _gwp_main_product_handle: gwpItem.properties?._gwp_main_product_handle || mainHandle,
        _uuid: targetUuid,
      };

      if (gwpItem.properties?.SKU) {
        nextProperties.SKU = gwpItem.properties.SKU;
      }

      if (gwpItem.properties?.Barcode) {
        nextProperties.Barcode = gwpItem.properties.Barcode;
      }

      await postCartChange({
        id: gwpItem.key,
        quantity: gwpItem.quantity || 1,
        properties: nextProperties,
      });
    }

    return true;
  };

  document.addEventListener("click", (event) => {
    const ctoCartDrawer = document.querySelector("cto-cart-drawer");
    if (!ctoCartDrawer || ctoCartDrawer.classList.contains("hidden")) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('cart-remove-button[data-typeofbutton="swremove"]');
    if (!button) return;

    const mainIndex = button.dataset?.mnprdctidx;
    const mainRow = mainIndex ? document.getElementById(`CartItem-${mainIndex}`) : null;
    const mainSku = mainRow?.dataset?.sku;
    const mainHandle = mainRow?.dataset?.handle;
    const fallbackGwpSkus = parseSkuList(mainRow?.dataset?.gwp_sku);

    if (!mainSku) return;

    window.setTimeout(async () => {
      try {
        const isUpdated = await syncGwpUuidForMainItem({
          mainSku,
          mainHandle,
          fallbackGwpSkus,
        });

        if (!isUpdated) return;

        if (!ctoCartDrawer.classList.contains("hidden")) {
          ctoCartDrawer.updateItems();
        }
      } catch (error) {
        // noop
      }
    }, 1700);
  });
}

function initModalObserver() {
  const modals = {};
  const acModals = Array.from(document.getElementsByClassName("ac-modal"));
  const acOpenModals = Array.from(document.querySelectorAll(".ac-modal-trigger[data-ajax-url], .ac-modal-trigger[data-modal-target]"));
  acModals.forEach((modalElement) => {
    const modal = modalElement;
    const modalId = modal.getAttribute("id");
    modals[modalId] = modal;
  });
  acOpenModals.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      lastOpenedModalId = trigger.getAttribute("data-modal-target");
    });
    const targetModalId = trigger.getAttribute("data-modal-target");
    const modal = modals[targetModalId];
    if (modal) {
      onAcModalClose(trigger, modal);
    }
  });
}

function onAcModalClose($trigger, $modal) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        const isOpen = mutation.target.classList.contains("modal-open");
        if (!isOpen) {
          const currentModalId = $modal.getAttribute("id");

          if (currentModalId === lastOpenedModalId) {
            publish(PUB_SUB_EVENTS.insuranceUpdate, { modalId: currentModalId });
          }
        }
      }
    });
  });
  const $modalRoot = $modal.closest(".modal");
  if (!$modalRoot) return;
  observer.observe($modalRoot, { attributes: true });
}

function priceInsuranceArray(element, id, type) {
  const insuranceString = element.dataset.priceInsurance;
  const insuranceArray = insuranceString?.replace(/'/g, '"')?.replace(/,]/, "]");
  if (insuranceArray) {
    const jsonArray = JSON.parse(insuranceArray);
    const currentInsurance = jsonArray.filter((item) => item.id === id)[0];
    if (type === "care_sec") {
      return currentInsurance?.price_care_sec;
    }
    if (type === "care") {
      return currentInsurance?.price_care;
    }
    if (type === "sec") {
      return currentInsurance?.price_sec;
    }
    if (type === "total") {
      return currentInsurance?.price_total;
    }
  }
  return null;
}

function isInsuranceAdded() {
  const insuranceCheckbox = $(".add-on-insurance-checkbox").toArray();
  return insuranceCheckbox.some((input) => $(input).is(":checked"));
}

function addedInsuranceParams(pageType = false) {
  const insuranceCheckbox = $("input.add-on-insurance-checkbox:checked")[0];
  const insuranceParent = $(insuranceCheckbox).parents(".add-on-product-style-insurance");

  return {
    secWarrantyID: pageType ? document.getElementById("secWarranty-varid")?.value : insuranceParent.find("#secWarranty-varid")?.val(),
    secWarrantysku: insuranceParent.find("#secWarranty-product-sku").val(),
    secWarrantympn: insuranceParent.find("#secWarranty-product-mpn").val(),
    secWarrantyhandle: insuranceParent.find("#secWarranty-product-handle").val(),
  };
}

function addInsuranceCTOItem() {
  const insuranceCTOButtons = document.querySelectorAll(".container-box-2");

  insuranceCTOButtons.forEach((insuranceCTOButton) => {
    if (insuranceCTOButton.dataset.insuranceCtoHandlerAttached === "true") {
      return;
    }

    insuranceCTOButton.addEventListener("click", (e) => {
      const currentButton = e.currentTarget;
      const buttonId = currentButton.dataset.index;

      updateInsuranceCTOItem(buttonId, insuranceCTOButtons, currentButton);
    });

    insuranceCTOButton.dataset.insuranceCtoHandlerAttached = "true";
  });
}

function addInsuranceItem(data, cto = "", variantChanged = false) {
  const insuranceButtons = document.querySelectorAll(".insurance-button");
  insuranceButtons.forEach((insuranceButton) => {
    if (insuranceButton.dataset.insuranceHandlerAttached === "true") {
      return;
    }

    insuranceButton.addEventListener("click", (e) => {
      const currentButton = e.currentTarget;
      const buttonId = currentButton.dataset.index;
      updateInsuranceItem(buttonId, data, currentButton, cto);
    });

    insuranceButton.dataset.insuranceHandlerAttached = "true";
  });
}

function updateInsuranceCTOItem(buttonId, containers, button) {
  const internalCTOButton = button?.classList.contains("internal");
  const secWarrantyVal = document.getElementById("secWarranty-varid");
  if (!internalCTOButton) {
    publish(PUB_SUB_EVENTS.insuranceUpdate, { buttonId, status: !button, type: "cto" });
  }

  containers.forEach((container) => {
    const containerInput = container.querySelector(".add-on-insurance-checkbox");
    if (containerInput) {
      const inputId = containerInput.dataset.id;
      containerInput.checked = inputId === buttonId;
      container.querySelector("label").classList.toggle("checked", inputId === buttonId);
      secWarrantyVal.value = buttonId;

      if (inputId === buttonId) {
        coverageCTOHeading(container.dataset, true);
      }
    }
  });

  coverageCTOItem(false);

  // TODO: EasyUpgrade conflict, must be checked
  // updatePriceAfterAddingCareOrInsurance();
}

function coverageCTOHeading(dataset, status) {
  const headingContainers = document.querySelectorAll(".js-cto-insurance-selected-option, .js-cto-summary-protection-value");
  const headingSummaryContainer = document.querySelector(".js-cto-summary-protection");
  const headingTitle = document.querySelector(".js-cto-insurance__subtitle");
  const headingTitleDataset = headingTitle?.dataset.heading;
  const { name, title } = dataset;

  if (headingContainers.length) {
    headingSummaryContainer.classList.remove("hidden");
    headingContainers.forEach((htmlContainer) => (htmlContainer.innerHTML = status ? name : SDG.Data.ctoNoCoverage));
    headingTitle.textContent = status ? title : headingTitleDataset;
  }
}

function updateInsuranceItem(buttonId, data, button, cto) {
  const internalButton = button && button.classList.contains("internal");
  const secWarrantyVal = document.getElementById("secWarranty-varid");
  const { add, remove } = data;

  if (!internalButton) {
    publish(PUB_SUB_EVENTS.insuranceUpdate, { buttonId, status: !button, ...(cto ?? { type: "cto" }) });
  }

  const insuranceItemCheckboxes = document?.querySelectorAll(".add-on-insurance-checkbox");
  insuranceItemCheckboxes.forEach((insuranceCheckbox) => {
    const insuranceBlock = insuranceCheckbox.closest(".add-on-product-style-insurance");
    const correctInsuranceInput = String(insuranceCheckbox.dataset.id) === buttonId && !insuranceCheckbox.checked;
    insuranceCheckbox.checked = correctInsuranceInput;

    if (correctInsuranceInput) {
      insuranceBlock.querySelector(".insurance-btn").innerHTML = remove;
      if (internalButton) {
        if (cto) {
          secWarrantyVal.value = buttonId;
        }
        const insuranceModalButtons = document.querySelectorAll(".pdp-insurance-btn-modal");
        insuranceModalButtons.forEach((button) => {
          button.classList.remove("hidden");
          const insuranceButton = button.nextElementSibling;
          insuranceButton?.classList.add("hidden");
        });
      }
    } else {
      insuranceBlock.querySelector(".insurance-btn").innerHTML = add;
    }

    // updatePriceAfterAddingCareOrInsurance();
  });
}

function coverageCTOItem(status) {
  const removeInsuranceBlock = document.getElementById("insurance-remove");
  const removeInsuranceInput = document.getElementById("remove-insurance");

  if (removeInsuranceBlock && removeInsuranceInput) {
    removeInsuranceInput.checked = status;
    removeInsuranceBlock.querySelector("label").classList.toggle("checked", status);
  }
}

function updatePriceAfterAddingCareOrInsurance() {
  const isAppleCareAdded = $("#add-apple-care").is(":checked");
  const inputElement = $("input.add-on-insurance-checkbox:checked")[0];
  const buttonID = $(inputElement).val();
  const hasTradeIn =
    $("#selected-trade-in-value").val() && $("#selected-trade-in-value").val() !== "0" && $("#selected-trade-in-device").val() !== "";
  const hiddenSelectedTradeInValue = $("#selected-trade-in-value").val();
  const tradeInPrice = hiddenSelectedTradeInValue ? formatMoney(hiddenSelectedTradeInValue) : 0;

  $(".js-product-price-with-care-warranty").each(function (i, $productPrice) {
    let price = $(this).attr("data-price");
    const nmpPriceCalculation = $(this).data("priceCalculation");

    if (isAppleCareAdded && isInsuranceAdded()) {
      price = priceInsuranceArray($productPrice, buttonID, "care");
    } else if (isAppleCareAdded) {
      price = $(this).attr("data-price-with-care");
    } else if (isInsuranceAdded()) {
      price = priceInsuranceArray($productPrice, buttonID, "total");
    } else if (hasTradeIn) {
      price = setPriceWithTradeIn("data-price", $productPrice);
    }

    $(this).html(price);
  });
}

function updatePriceAfterRemovingTradeInInsurance() {
  const isAppleCareAdded = $("#add-apple-care").is(":checked");
  const insuranceCheckbox = $(".add-on-insurance-checkbox").toArray();
  const insuranceChecked = (input) => $(input).is(":checked");
  const insuranceItem = insuranceCheckbox.filter(insuranceChecked)[0];
  const insuranceId = insuranceItem?.dataset.id;
  const isTradeInAdded = document.querySelector("#selected-trade-in-value")?.value;
  const $productPrices = document.querySelectorAll(".js-product-price-with-care-warranty");

  $(".js-product-price-with-care-warranty").each((i, $productPrice) => {
    const price = $($productPrice).data("price");
    let updatedPrice;

    /* TO BE ADDED */
    if (isTradeInAdded && isAppleCareAdded && insuranceItem) {
      updatedPrice = priceInsuranceArray($productPrice, insuranceId, "care");
    } else if (isTradeInAdded && isAppleCareAdded) {
      updatedPrice = $($productPrice).attr("data-price-with-care");
    } else if (isTradeInAdded && insuranceItem) {
      updatedPrice = priceInsuranceArray($productPrice, insuranceId, "total");
    } else if (isTradeInAdded) {
      updatedPrice = price;
    } else {
      updatedPrice = price;
    }

    $($productPrice).html(updatedPrice);
  });
}

function setInsurancePriceWithTradeIn(insurance) {
  const tradeInPriceEl = $("#selected-trade-in-value").val();

  if (!insurance || !tradeInPriceEl) return;

  const tradeInPrice = formatMoney(tradeInPriceEl);
  const priceWithAddOnOptions = formatMoney(insurance);
  const finalPrice = priceWithAddOnOptions < tradeInPrice ? 0.0 : priceWithAddOnOptions - tradeInPrice;

  return formatPriceWithCurrency(finalPrice);
}

function addOtherInsuranceCart(params = {}) {
  const { variantId = "", mainProductId = "" } = params;
  const ctoCartDrawer = document.querySelector("cto-cart-drawer");
  const hasOtherItem = Boolean(variantId && mainProductId);
  addOtherIInsuranceItem = {
    status: hasOtherItem,
    data: params,
  };

  if (hasOtherItem && !ctoCartDrawer) {
    addInsuranceButton(params);
  }
}

const addOtherCTOInsuranceCart = () => {
  const { status = false, data = {} } = addOtherIInsuranceItem;
  if (status) {
    addInsuranceButton(data);
  }

  initModalObserver();
};

const addInsuranceButton = (params) => {
  const { variantId = "", mainProductId = "" } = params;
  const insuranceButtons = variantId && $(`button[data-variantid=${variantId}]`);
  const insuranceButton = insuranceButtons?.filter((index, item) => item.dataset.mainproductid === mainProductId?.toString());

  if (insuranceButton?.length) {
    $(insuranceButton).prev().removeClass("hidden");
    insuranceButton.click();
  } else {
    const insuranceBlocks = $(".four-not-added.insurance");
    skeletonLoaderHandler();
    insuranceBlocks.each((item) => {
      item.children?.[0]?.classList.add("hidden");
    });
  }

  initModalObserver();
};

const skeletonLoaderHandler = (id = "") => {
  const skeletons = document.querySelectorAll(".skeleton-overlay");
  const cartButtons = document.querySelectorAll(".add-cart-apple-care, cart-remove-button");

  skeletons.forEach((skeleton) => {
    const skeletonId = skeleton.dataset.mainproductid;
    const parentElement = skeleton.parentElement;
    const emptyBlock = parentElement.querySelector(".empty-div-desktop");
    const { width, height, top, left } = parentElement.getBoundingClientRect();
    const blockWidth = emptyBlock ? width - emptyBlock.offsetWidth - 24 : width;

    skeleton.style.width = `${blockWidth}px`;
    skeleton.style.height = `${height}px`;
    skeleton.classList.toggle("hidden", id !== skeletonId);
  });

  cartButtons.forEach((button) => {
    const buttonMainProductId = button.dataset.mainproductid;
    if (id) {
      button.disabled = id !== buttonMainProductId;
      button.classList.toggle("force-disabled", id !== buttonMainProductId);
    } else {
      button.disabled = false;
      button.classList.remove("force-disabled");
    }
  });
};

function disableLockScreen() {
  const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
  mainCartItems?.classList?.remove("cart__items--disabled");
}
